import React from 'react';
import classNames from 'classnames';
import styles from './PlayerStatsCard.module.scss';
import PlaceholderJugador from 'containers/Mundial2026/assets/placeholders/Jugador.png';

const PlayerStatsCard = ({ player = {}, columns = [], codeTranslations = {}, bindHeaderTooltip }) => {
  const { name = '', number, image } = player;
  const hasNumber =
    number !== null && number !== undefined && number !== '';

  return (
    <article className={styles['player-stats-card']}>
      <header className={styles['player-stats-card__header']}>
        <div className={styles['player-stats-card__photo']}>
          <img
            className={styles['player-stats-card__photo-image']}
            src={image || PlaceholderJugador}
            alt={name}
            onError={e => { e.currentTarget.onerror = null; e.currentTarget.src = PlaceholderJugador; }}
          />
        </div>

        <span
          className={styles['player-stats-card__divider']}
          aria-hidden
        />

        <div className={styles['player-stats-card__identity']}>
          <p className={styles['player-stats-card__name']}>{name}</p>
          {hasNumber && (
            <p className={styles['player-stats-card__number']}>#{number}</p>
          )}
        </div>
      </header>

      <div className={styles['player-stats-card__stats']}>
        {/* Fila superior: códigos */}
        <div
          className={classNames(
            styles['player-stats-card__stats-row'],
            styles['player-stats-card__stats-row--codes'],
          )}
        >
          {columns.map((column, idx) => {
            const tooltipLabel = codeTranslations[column.code] || column.code;
            return (
              <span
                key={`code-${column.code}-${idx}`}
                className={classNames(styles['player-stats-card__code'], {
                  [styles['player-stats-card__code--highlighted']]:
                    column.isHighlighted,
                })}
                aria-label={`${column.code}: ${tooltipLabel}`}
                {...(bindHeaderTooltip ? bindHeaderTooltip(tooltipLabel) : {})}
              >
                {column.code}
              </span>
            );
          })}
        </div>

        {/* Fila inferior: valores */}
        <div
          className={classNames(
            styles['player-stats-card__stats-row'],
            styles['player-stats-card__stats-row--values'],
          )}
        >
          {columns.map((column, idx) => (
            <span
              key={`value-${column.code}-${idx}`}
              className={classNames(styles['player-stats-card__value'], {
                [styles['player-stats-card__value--highlighted']]:
                  column.isHighlighted,
              })}
            >
              {column.value}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
};

export default PlayerStatsCard;

/*
<PlayerStatsCard
  player={{
    name: 'Sébastien Haller',
    number: 9,
    image: '/img/players/haller.jpg',
  }}
  columns={[
    { code: 'G',   value: 8,  isHighlighted: true },
    { code: 'PAG', value: 12 },
    { code: 'TT',  value: 24 },
    { code: 'TAP', value: 18 },
    { code: 'A',   value: 4 },
    { code: 'P',   value: 2 },
    { code: 'TA',  value: 1 },
  ]}
/>
*/
